class SseStreamUtils {
    private UriPrefix = `${import.meta.env.VITE_API_HOST}`;
    public createEventSource(url: string, options = {}): EventSource {
        if (!url) {
            throw new Error('URL is required to create an EventSource');
        }
        const eventSource = new EventSource(this.UriPrefix + url, options);
        eventSource.onerror = (error) => {
            console.error('EventSource failed:', error);
            eventSource.close();
        };
        return eventSource;
    }

    public closeEventSource(eventSource: EventSource): boolean {
        if (eventSource && typeof eventSource.close === 'function') {
            eventSource.close();
        }
        return true;
    }
}

export default new SseStreamUtils();
